// extracted by mini-css-extract-plugin
export default {"download":"styles_download__P0OjV","motif":"styles_motif__lJoRG","motif2":"styles_motif2__wXNIU","inner":"styles_inner__gZqcZ","kicker":"styles_kicker__yabyL"};